module.exports = __webpack_public_path__ + "static/media/selfie_example.6f2474da.jpeg";